import httpClient from '../../services/httpClient';
import { Product } from '../product/types';

export interface FavoritesResponse {
  products: Product[];
}

export interface FavoriteStatusResponse {
  isFavorite: boolean;
}

export const favoritesService = {
  async getFavorites(): Promise<FavoritesResponse> {
    const response = await httpClient.get('/api/Users/favorites');
    return {
      products: Array.isArray(response.data?.products) ? response.data.products : [],
    };
  },

  async getStatus(productId: number): Promise<FavoriteStatusResponse> {
    const response = await httpClient.get(`/api/Users/favorites/${productId}/status`);
    return {
      isFavorite: response.data?.isFavorite === true,
    };
  },

  async add(productId: number): Promise<FavoriteStatusResponse> {
    const response = await httpClient.post(`/api/Users/favorites/${productId}`);
    return {
      isFavorite: response.data?.isFavorite === true,
    };
  },

  async remove(productId: number): Promise<FavoriteStatusResponse> {
    const response = await httpClient.delete(`/api/Users/favorites/${productId}`);
    return {
      isFavorite: response.data?.isFavorite === true,
    };
  },
};
